module.exports = __webpack_public_path__ + "img/icon-qr-code.c805173c.jpg";